<template>
    <DModal
        :show="showModal"
        :title="__('tools.php_eol.batch_process_actions.title')"
        :message="__('tools.php_eol.batch_process_actions.message')"
        @close="modalClosed"
        @confirm="submitForm"
    >
        <template #default>
            <DCard
                padding
            >
                <DFormRow
                    :label="__('tools.php_eol.batch_process_actions.batch_select')"
                    is-required
                    :error="errorsData.number_of_contracts"
                >
                    <DSelect
                        v-model="form.batch_id"
                        :options="batchOptions"
                        :disabled="batchId !== null"
                    />
                </DFormRow>
                <DFormRow
                    v-if="isSkippingProcessAllowed"
                    :label="__('tools.php_eol.batch_process_actions.skip_processing')"
                    is-required
                    :error="errorsData.number_of_contracts"
                    :hint="skippingProcessingHint"
                >
                    <DSwitch
                        v-model="form.skip_processing"
                        color="success"
                        variant="3d"
                    />
                </DFormRow>
            </DCard>
        </template>
    </DModal>
</template>

<script setup>

import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref } from 'vue'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    batches: {
        type: Array,
        default: () => { return [] }
    },
    batchId: {
        type: Number,
        default: () => {
            return null
        }
    },
    action: {
        type: String,
        default: () => {
            return null
        }
    },
    activeModule: {
        type: String,
        default () {
            return ''
        }
    },
    isSkippingProcessAllowed: {
        type: Boolean,
        default: () => {
            return false
        }
    }
})

const skippingProcessingHint = '<span class="text-danger">' + __('tools.php_eol.batch_process_actions.skip_processing_hint') + '</span>'

const errorsData = ref(props.errors)

const batchOptions = computed(() => {
    return props.batches.map((batchId) => {
        return {
            label: 'Batch ' + batchId,
            value: batchId
        }
    })
})

const form = useForm({
    module: props.activeModule,
    batch_id: props.batchId,
    skip_processing: false,
})

const emit = defineEmits(['close-modal', 'form-submitted'])

const submitForm = () => {
    form.post(route(props.action), {
        onSuccess: () => {
            emit('form-submitted')
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        },
        onFinish: () => {
            form.number_of_contracts = null
        }
    })
}

const modalClosed = () => {
    emit('close-modal')
    form.reset()
    errorsData.value = {}
}
</script>
